export enum FormPlugin {
  FORM_BUILDER = 'form-builder',
  GET_SUBSCRIBERS = 'get-subscribers',
  REGISTRATION_FORM = 'registration-form',
  CAPTCHA = 'CAPTCHA'
}
